import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./Inner_Page_Banner.css";
import { ServiceId } from "../../../../utils/apis/service/Service";
import { IDS } from "../../../../utils/common";
import { Context } from "../../../../utils/context";

const Inner_Page_Banner = () => {
  const navigate = useNavigate();

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { id } = useParams();
  const { IMG_URL } = useContext(Context);

  const [servicebanner, setServiceBanner] = useState({});

  const getServiceBanner = async () => {
    const res = await ServiceId(id);

    if (res?.success) {
      setServiceBanner(res?.data || {});
    }
  };

  useEffect(() => {
    if (id) {
      getServiceBanner();
    }
  }, [id]);

  return (
    <section className="residential_service">
      <div className="container">
        {/* Breadcrumb */}
        {/* <div className="breadcrumb_wrapper">
          <span className="breadcrumb_link" onClick={() => navigate(-1)}>
            Service
          </span>
          <span className="breadcrumb_separator"> &gt; </span>
          <span className="breadcrumb_active">
            Why Solar Energy Is the Smartest Investment for Indian Homes
          </span>
        </div> */}

        <div className="service_banner">
          {/* ✅ Image + Overlay Wrapper */}
          <div className="service_banner_div">
            <img
              src={IDS?.IMG_URL + servicebanner?.image}
              alt="Residential Rooftop Solar"
              className="banner_img"
            />

            <div className="banner_overlay">
              <h2 className="banner_heading">
                {htmlToReactParser.parse(servicebanner?.name)}
              </h2>
            </div>
          </div>

          {/* ✅ Description BELOW image */}
          <div className="service_description_div">
            <h5 className="desc_heading">Service Description:</h5>
            <p className="service_desc">
              {htmlToReactParser.parse(servicebanner?.description)}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inner_Page_Banner;
